import styled from 'styled-components';

export const PageContent = styled.div<{ isMobileApp: boolean }>`
  display: flex;
  position: relative;
  top: ${({ isMobileApp }) => !isMobileApp && `72px`};
`;
